<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [commas]="2" [label]="label" />
